<template>
  <div>
    <navigation-container/>
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import NavigationContainer from '@/containers/Navigation'

export default {
  components: {
    NavigationContainer
  },
  created () {
    this.fetchFilters()
  },
  methods: {
    ...mapActions(['fetchFilters'])
  }
}
</script>

<style lang="scss">
  @import '~normalize.css';
  @import '~@/assets/sass/transitions';

  @font-face {
    font-family: $suisse-font;
    font-weight: 400;
    src: url("/fonts/SuisseIntl-Book.otf");
  }

  @font-face {
    font-family: $suisse-font;
    font-weight: 400;
    font-style: italic;
    src: url("/fonts/SuisseIntl-BookItalic.otf");
  }

  @font-face {
    font-family: $suisse-font;
    font-weight: 500;
    font-style: italic;
    src: url("/fonts/SuisseIntl-Medium.otf");
  }

  @font-face {
    font-family: $suisse-font;
    font-weight: 600;
    src: url("/fonts/SuisseIntl-SemiBold.otf");
  }

  :root {
    --red: $main-color;
    --black: $secondary-color;
    --main: var(--red);
    --main-opposite: var(--black);
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  html,
  body {
    overflow-x: hidden;
  }

  body {
    @include font-smoothing;
    @include theme(color);

    font-family: $base-font;
    font-size: $p-font-size;
    line-height: $vertical-space;
    background-color: $bg-color;

    @include media-up(md) {
      font-size: $md-p-font-size;
    }
  }

  h1,
  h2,
  h3,
  h4,
  p {
    margin: 0;
  }

  h1,
  h2,
  h3,
  h4 {
    @include text(big, bold);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue